import { useEffect, useState } from "react";
import axios from "axios";
import pricingFallback from "../config/pricingFallback.generated.json";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fuente única de precios (Fase 0 de NEXO): PageTypesPricing.jsx y
// Pricing.jsx consumen GET /api/pricing en vez de arrays hardcodeados. Si
// el fetch falla, se usa el respaldo estático embebido en el build (ver
// scripts/generate-pricing-fallback.js) para que la página de precios
// nunca aparezca rota — puede quedar desactualizada unas horas en el peor
// caso, aceptable dado el volumen de cambios de precio.
const usePricingData = () => {
  const [data, setData] = useState(pricingFallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/pricing`)
      .then((res) => {
        if (!cancelled) setData(res.data);
      })
      .catch(() => {
        // Nos quedamos con pricingFallback, ya asignado como estado inicial.
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading };
};

export default usePricingData;
